import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-default page-media" }
const _hoisted_2 = { class: "page-path path-links" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1)
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "right c-app" }

import movies, { State } from '@/store/movies/publish';
import { computed } from 'vue';
import { useStore } from 'vuex';
import Content from '../hot/Content.vue';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[movies.name])
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "link",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(lang).topMenu.movie), 1)
        ]),
        _: 1
      }),
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString(_unref(lang).movieMenu.new_add), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("b", null, _toDisplayString(_unref(lang).movieMenu.new_add), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(lang).movieText.add_intro), 1)
    ]),
    _createVNode(Content, {
      data: _unref(data).albums
    }, null, 8, ["data"])
  ]))
}
}

})